import { ReactComponent as Share } from 'assets/icons/icon-share.svg';

export default Share;
